import { defaultStore } from './defaultStore';
import { defineStore } from "pinia";

export default defineStore('chemical_cards', defaultStore('chemicals_compounds/chemical_cards/',));
